/*
 * Copyright (c) 2019 Cédric Bodet.
 * The MIT License
 * http://www.opensource.org/licenses/mit-license
 */
import 'worldwindjs' //WorldWind global
import EnhancedWmsLayer from '../../globe/api/EnhancedWmsLayer'
import React from 'react'

/* global WorldWind */

export default class TampereSolarEnergyPotentialOfBuildings extends EnhancedWmsLayer {
    constructor() {
        let cfg = {
            title: "Solar Energy Potential of Buildings",
            service: "https://geodata.tampere.fi/geoserver/wms?service=WMS",
            version: "1.3.0",
            layerNames: "ilmasto_ja_energia:aurinkoenergiapotentiaali_polygon_tm35",
        };

        super(cfg);

        this.urlBuilder.transparent = true;
    }

    doRender(dc) {
        super.doRender(dc);
        if (this.inCurrentFrame) {
            dc.screenCreditController.addCredit(
                " Open Data Tampere",
                WorldWind.Color.LIGHT_GRAY);
        }
    }

    getLayerDisplayInformation() {
        return (<div>
            <p>Tampereen kaupungin aurinkoenergiapotentiaali Tampereen kaupungin auringosta saatava säteilyenergia,
                aurinkoenergian tuotannolle sopivat sijainnit sekä sähkön- lämmön tuotantopotentiaali (MWh/vuosi)
                rakennuksittain. Aineisto koostuu kolmesta tasosta: 1) auringon säteilyenergia katoille, kWh/m2/vuosi
                (tiff), 2) aurinkoenergian tuotannolle sopiva ala katolla ja 3) pinta-ala (m2) sekä aurinkolämmön ja
                sähkön tuotantopotentiaali (kWh/v) rakennuksittain. Aurinkoenergia-analyysissä selvitetyt
                aurinkoenergian tuotantopotentiaalit on laskettu olemassa olevien rakennusten kattopinnoilta. Menetelmä
                huomioi suoran säteilyn lisäksi diffuusin ja siroavan säteilyn, pilvisyyden, ilmankosteuden, lämpötilan,
                ympäristön varjostukset(puut, kasvillisuus, muut rakennukset) sekä katonomien rakenteiden varjostukset
                ja kattojen kaltevuudet. Aurinkoenergiapotentiaaliselvityksen aineisto tuotettiin jokaisesta saatavilla
                olleista rakennusten kattopinnoista yhden neliömetrin tarkkuudella. Käytetty lähdeaineisto on tuotettu
                alueellisesti vuosina 2008 - 2014, joten analyysi sisältää vähintään kaikki ennen vuotta 2008 rakennetut
                rakennukset. Kattopinta-alat on aurinkoenergian tuottavuutensa perusteella jaettu kolmeen luokkaan: hyvä
                (aurinkosäteily &gt;900 kWh/m2/a), tyydyttävä (aurinkosäteily 750-900 kWh/m2/a) ja välttävä
                (aurinkosäteily &lt;750kWh/m2/a). Sähkön vuosituoton potentiaalia laskettaessa on oletettu aurinkopaneelien
                                                      hyötysuhteeksi 15 % ja niiden olevan asennettu katon suuntaisesti
                                                      myös tasakatoilla. Aurinkolämmön hyötysuhteeksi on oletettu 40 %.
            </p>
        </div>);
    }
}
